import Vue from 'vue';
import VueTinySlider from 'vue-tiny-slider';

$('.e-testimonials').each(function () {
    const testmionialElement = new Vue({
        el: $(this)[0],
        components: {
            'tiny-slider': VueTinySlider
        }
    });
});